import { Flex, Text } from '@chakra-ui/react';
import { Slash } from 'react-feather';
import React from 'react';

const Toast = ({ label, variant, onClick, customWidth = '400px'}) => {
	const color = variant === 'info' ? '#002575' : 'gray';
	const backgroundColor = variant === 'info' ? '#EDF3FA' : 'lightgray';
	return (
		<Flex
			alignItems={'center'}
			mb={20}
			width={customWidth}
			height="60px"
			style={{
				cursor: !!onClick && 'pointer',
				borderRadius: '15px',
				backgroundColor
			}}
			onClick={onClick}
		>
			<Flex justifyContent="center" width="80px">
				<Slash size={'34px'} color={color} />
			</Flex>
			<Text
				textAlign={'center'}
				color={color}
				width={'320px'}
				style={{
					marginBottom: 0
				}}
				m={'auto'}
				fontSize={'14px'}
				fontFamily={'Poppins Semibold'}
			>
				{label}
			</Text>
		</Flex>
	);
};

export default Toast;
